export const thirdPartyAgreementKeys = {
    detail: (vrm: string, reference: string) => ['third-party-agreement', vrm, reference] as const,
    invoicing: (vrm: string, reference: string) => ['third-party-agreement', vrm, reference, 'invoicing'] as const,
    invoiceSubmit: (vrm: string, reference: string) =>
        ['third-party-agreement', vrm, reference, 'invoice-submit'] as const,
    invoiceNotice: (vrm: string, reference: string, visit: string) =>
        ['third-party-agreement', vrm, reference, 'invoice-notice', visit] as const,
    invoiceableDealers: (vrm: string, reference: string) =>
        ['third-party-agreement', vrm, reference, 'invoiceable-dealers'] as const,
};
